<template>
  <div>
    <div class="item mt-2.5 bg-[#2c2c2c] box-border rounded-xl p-4">
      <div class="flex justify-between box-border items-center">
        <div style="flex">
          <span class="opacity-70">时间</span>
        </div>
        <div
          class="border border-transparent min-h-[34px] flex items-center pr-3"
          :class="{
            'border-border-active': hover
          }"
        >
          <a-time-picker
            v-model:value="currentTime"
            :use-12-hours="!isMiscIs24H"
            :input-read-only="false"
            :allow-clear="false"
            :format="format"
            :show-now="false"
            :bordered="false"
            :open="pickerOpen"
            @open-change="(o:boolean) => (pickerOpen = o)"
            @change="update"
          />
        </div>
      </div>
      <div>
        <a-slider
          :min="0"
          :max="60 * 60 * 24 - 1"
          class="mx-0"
          :tip-formatter="(v: number)=>dayjs().hour(0).minute(0).second(0).second(v).format(format)"
          :value="getSeconds(currentTime)"
          @change="(v: number)=>{currentTime = dayjs().hour(0).minute(0).second(v);update()}"
        />
      </div>
      <div class="flex">
        <div
          v-for="stage in timeSections"
          :key="stage.label"
          class="flex-1 py-2 cursor-pointer ring-white/40 flex items-center justify-center text-[10px] rounded-[6px] opacity-0.7 hover:ring-1"
          :class="{
            'opacity-1 font-medium bg-[#4A4A4A]':
              runtimeStore.configDataWhole['miscTimeSection'] == stage.value
          }"
          @click="
            () => {
              currentTime = stage.start;
              update();
            }
          "
        >
          {{ stage.label }}
        </div>
      </div>
    </div>
    <div class="grid grid-cols-3"></div>
  </div>
</template>
<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useDataSource } from '@/hooks';
import { getTimeSectionOptions } from '@/watch-renderer/runtime/config-data';
import { useRuntimeStore } from '@/store/use-runtime-store';
dayjs.extend(duration);

defineProps({
  hover: {
    type: Boolean,
    default: false
  }
});

const getSeconds = (t: dayjs.Dayjs) =>
  t.hour() * 3600 + t.minute() * 60 + t.second();

const isMiscIs24H = computed(() => configData.value['miscIs24H'] == 1);
const format = computed(() =>
  isMiscIs24H.value
    ? 'HH:mm:ss'
    : 'h:mm:ss ' + (currentTime.value.hour() >= 12 ? '下午' : '上午')
);

const runtimeStore = useRuntimeStore();
const timeSections = computed(() => {
  return getTimeSectionOptions(runtimeStore.configDataWhole);
});

const pickerOpen = ref(false);
const currentTime = ref(dayjs('17:29:35', 'HH:mm:ss'));
// slider 刻度
// const sliderMarks = computed(() =>
//   stages.reduce((acc, cur) => {
//     acc[getSeconds(parseTime(cur.start))] = {};
//     return acc;
//   }, {} as Record<number, Record<never, never>>)
// );
const { configData, setValues } = useDataSource();
const init = () => {
  const data = configData.value;
  currentTime.value = currentTime.value
    .hour(data['timeHour'] as number)
    .minute(data['timeMinute'] as number)
    .second(data['timeSecond'] as number);
};
init();
// 更新时间数据
watch(configData, (newData) => {
  currentTime.value = currentTime.value
    .hour(Math.floor(newData['timeHour'] as number))
    .minute(newData['timeMinute'] as number)
    .second(newData['timeSecond'] as number);
});
const update = () => {
  const t = currentTime.value;

  setValues({
    timeHour: t.hour(),
    timeMinute: t.minute(),
    timeSecond: t.second()
  });
};
</script>
<style lang="less" scoped>
.item {
  &:deep(.ant-slider) {
    .ant-slider-track {
      box-sizing: border-box;
      background-color: #0d84f2;
    }
    .ant-slider-rail {
      border-radius: 5px;
      background-color: #626262;
    }
    .ant-slider-handle {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 2px solid #fff;
    }
    .ant-slider-dot-active {
      border-color: #fff;
    }
  }
  &:deep(.ant-input-number) {
    border: 2px solid #626262;
    border-radius: 4px;
  }
  &:deep(.ant-picker) {
    padding: 0;
    input {
      text-align: end;
      font-size: 16px;
      font-weight: 500;
    }
    .ant-picker-suffix {
      display: none;
    }
  }
}
</style>
